import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { defaultTrackTargets } from '../../../models/types.ClientDTO'

import './Toggle.css'

const CLASS = 'insights-portal-toggle'

const Toggle = props => {
  const className = props.className || CLASS

  const show = props.show || false

  const trackTarget = props.trackTarget || 'entity'
  const caption = props.caption || defaultTrackTargets[trackTarget]?.caption

  const showRef = useRef(show)
  const mountedRef = useRef(false)

  const [iconClass, setIconClass] = useState(() => `${className}-icon-${show ? 'open' : 'closed'}`)
  const [containerClass, setContainerClass] = useState(() => `${className}-${show ? 'open' : 'closed'}`)

  useEffect(() => {
    if (mountedRef.current) {
      if (showRef.current !== show) {
        showRef.current = show
        setIconClass(() => `${className}-icon-${show ? 'do-open' : 'do-close'}`)
        setContainerClass(() => `${className}-${show ? 'do-open' : 'do-close'}`)
      }
    } else mountedRef.current = true
  }, [className, show])

  const click = () => {
    if (props.onChange) props.onChange({ show: !props.show, section: caption })
  }

  const text = `${props.show ? 'Hide' : 'Show'} ${caption.toLowerCase()}`

  return (
    <div className={`${className} ${containerClass}`} onClick={click}>
      <div></div>
      <div className={`${CLASS}-text`}>{text}</div>
      <div className={`${className}-icon ${iconClass}`}>
        <i className={`pi pi-chevron-down ${className}-icon-i`}></i>
      </div>
    </div>
  )
}

Toggle.propTypes = {
  className: PropTypes.string,
  show: PropTypes.any,
  trackTarget: PropTypes.oneOf(['attribute', 'entity']),
  caption: PropTypes.string,
  onChange: PropTypes.func
}

Toggle.defaultProps = {
  name: 'attributes',
  show: true,
  trackTarget: 'entity'
}

export default Toggle
